import React, { useState, useEffect } from 'react';
import { theme, fontStack, bodyFont } from '../theme';
import { CrossIcon } from './shared';
import { useChurchData } from '../data/ChurchDataProvider';

const BASE_PAGES = ["Home", "About", "Announcements", "Resources"];

export default function Navigation({ currentPage, setCurrentPage }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { data } = useChurchData();

  const PAGES = data.givingEnabled
    ? [...BASE_PAGES, "Giving", "Join Us"]
    : [...BASE_PAGES, "Join Us"];

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <>
      <nav style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000,
        padding: scrolled ? "12px 0" : "20px 0",
        background: scrolled ? theme.bgGlass : "transparent",
        backdropFilter: scrolled ? "blur(20px) saturate(1.5)" : "none",
        borderBottom: scrolled ? `1px solid ${theme.border}` : "none",
        transition: "all 0.4s ease",
      }}>
        <div style={{
          maxWidth: 1200, margin: "0 auto", padding: "0 24px",
          display: "flex", alignItems: "center", justifyContent: "space-between",
        }}>
          {/* Logo */}
          <div
            onClick={() => { setCurrentPage("Home"); setMobileOpen(false); window.scrollTo({ top: 0, behavior: "smooth" }); }}
            style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 12 }}
          >
            <CrossIcon size={28} />
            <div>
              <div style={{
                fontFamily: fontStack, fontSize: 18, fontWeight: 600, color: theme.cream,
                letterSpacing: "0.05em", lineHeight: 1.1,
              }}>NEW PROSPECT</div>
              <div style={{
                fontFamily: bodyFont, fontSize: 10, fontWeight: 400,
                color: theme.gold, letterSpacing: "0.25em", textTransform: "uppercase",
              }}>Baptist Church</div>
            </div>
          </div>

          {/* Desktop Nav */}
          <div className="desktop-nav" style={{ display: "flex", alignItems: "center", gap: 32 }}>
            {PAGES.map((p) => (
              <button
                key={p}
                className={`nav-link ${currentPage === p ? "active" : ""}`}
                onClick={() => { setCurrentPage(p); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              >{p}</button>
            ))}
            <button
              onClick={() => { setCurrentPage("Join Us"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              className="nav-visit-btn"
            >Visit Us</button>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="mobile-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
            style={{ position: "relative", zIndex: 1002 }}
          >
            <div style={{ width: 24, height: 16, position: "relative" }}>
              {[0, 7, 14].map((t, i) => (
                <span key={i} style={{
                  position: "absolute", left: 0, top: t, width: 24, height: 2,
                  background: theme.gold, borderRadius: 1,
                  transition: "all 0.3s",
                  ...(mobileOpen && i === 0 ? { top: 7, transform: "rotate(45deg)" } : {}),
                  ...(mobileOpen && i === 1 ? { opacity: 0 } : {}),
                  ...(mobileOpen && i === 2 ? { top: 7, transform: "rotate(-45deg)" } : {}),
                }} />
              ))}
            </div>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay — outside nav to avoid z-index stacking issues */}
      <div style={{
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(10,10,15,0.97)", backdropFilter: "blur(30px)",
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", gap: 32,
        opacity: mobileOpen ? 1 : 0,
        pointerEvents: mobileOpen ? "auto" : "none",
        transition: "opacity 0.4s ease",
        zIndex: 1001,
      }}>
        {PAGES.map((p, i) => (
          <button
            key={p}
            onClick={() => { setCurrentPage(p); setMobileOpen(false); window.scrollTo({ top: 0, behavior: "smooth" }); }}
            style={{
              background: "none", border: "none", cursor: "pointer",
              fontFamily: fontStack, fontSize: 32, fontWeight: 300,
              color: currentPage === p ? theme.gold : theme.cream,
              letterSpacing: "0.08em", transition: "all 0.3s",
              opacity: mobileOpen ? 1 : 0,
              transform: mobileOpen ? "translateY(0)" : "translateY(20px)",
              transitionDelay: `${i * 0.1}s`,
            }}
          >{p}</button>
        ))}
      </div>
    </>
  );
}
